import React, { useEffect, useState } from "react";
import "./avatarImageWithFallback.css";

function PersonSilhouette() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable="false"
    >
      <path
        d="M12 11.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM4 20.5v-1C4 15.8 7.58 13 12 13s8 2.8 8 6.5v1H4z"
        fill="currentColor"
        fillOpacity="0.9"
      />
    </svg>
  );
}

/**
 * Profile / organiser thumbnail: shows image when load succeeds, otherwise a neutral icon.
 */
export default function AvatarImageWithFallback({
  src,
  alt = "",
  width = 24,
  height = 24,
  className = "",
  rounded = true,
}) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const w = Number(width) || 24;
  const h = Number(height) || 24;

  const safeSrc = typeof src === "string" ? src.trim() : src;
  const label = typeof alt === "string" && alt.trim() ? alt : "Avatar";

  const rootClass = [
    "avatar-img-with-fallback",
    rounded && "avatar-img-with-fallback--rounded",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (!safeSrc) {
    return (
      <span
        className={`${rootClass} avatar-img-with-fallback--placeholder`}
        style={{ width: w, height: h }}
        role="img"
        aria-label={label}
      >
        <PersonSilhouette />
      </span>
    );
  }

  if (failed) {
    return (
      <span
        className={`${rootClass} avatar-img-with-fallback--placeholder`}
        style={{ width: w, height: h }}
        role="img"
        aria-label={label}
      >
        <PersonSilhouette />
      </span>
    );
  }

  return (
    <img
      className={rootClass}
      src={safeSrc}
      alt={alt || ""}
      width={w}
      height={h}
      decoding="async"
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
